<template>
  <!-- -->
  <div class="banner-setting mini-component">
    <div class="desc">
      可以上传多张图片，图片尺寸无要求，但需要所有的图片尺寸一致
    </div>
    <div v-if="showList">
      <div v-for="(item, idx) in bannerList" :key="idx" @click="toSetting(item, idx)">
        <alone-image-setting :data="item" @remove="removeOne(idx)"/>
      </div>
      <page-button style="width: 100%" @click="addNew">添加图片</page-button>
    </div>
    <div v-else>
      <page-button @click="showList = true">返回</page-button>
      <alone-data v-model="currentData" @change="changeData" :show-tag="false" :show-background="false" :show-icon="false"/>
    </div>

  </div>
</template>

<script>

import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
import AloneImageSetting from "@/views/h5/common/sys/miniProgram/setting/component/AloneImageSetting.vue";

export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    AloneImageSetting,
    AloneData
  },
  data() {
    return {
      showList: true,
      currentData: {},
      bannerList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.bannerList = [
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: "690*250"},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: "690*250"},
        ];
      } else {
        this.bannerList = this.data.componentData;
      }
    },
    // 添加一个新的
    addNew() {
      let data = {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: "690*250"};
      this.currentData = data;
      this.currentIndex = this.bannerList.length;
      this.bannerList.push(data);
      this.showList = false;
    },
    // 移除一个图片
    removeOne(idx) {
      this.bannerList.splice(idx, 1);
      // 将数据向上级提交
      this.$emit("change", {
        ...this.data,
        componentData: this.bannerList
      });
    },
    toSetting(data, idx) {
      this.currentData = data;
      this.currentIndex = idx;
      this.showList = false;
    },
    // 数据变更
    changeData() {
      this.bannerList[this.currentIndex] = this.currentData;
      // 将数据向上级提交
      this.$emit("change", {
        ...this.data,
        componentData: this.bannerList
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>